
<div class="marketplace-wrapper">
  <main-nav :title="$t('editor.header.marketplace.title')" />
  <cvt-popup-choose-template :mode="mode" />
</div>
